export default __webpack_public_path__ + "static/media/EmptyTrailer.db35dfcc.svg";